/**
 * Include your custom JavaScript here.
 */

/**
 * Judge.me cosmetic fixes — applied the instant the widget renders.
 *
 * Judge.me lazy-loads its review content, so a one-shot setTimeout races the
 * render: too early and it misses, too late and the raw text (">>" reply prefix,
 * "5.00" average) flashes visibly for ~3s. A MutationObserver catches every
 * render/update and fixes both immediately, with an initial pass for content
 * that's already present.
 *
 *  (1) Reply prefix ">>": Judge.me puts ">>" in the FIRST text node of
 *      .jdgm-rev__replier-wrapper (before the <b> name). We blank that node so
 *      the label reads "Kija Hair Salon replied:" with no arrows. (Removing it
 *      at the source needs a paid plan, so we strip it client-side.)
 *  (2) Summary average decimal: trim "5.00" -> "5.0" on .jdgm-rev-widg__summary-average.
 */
(function () {
  'use strict';

  function stripReplyArrows(root) {
    (root || document).querySelectorAll('.jdgm-rev__replier-wrapper').forEach(function (wrapper) {
      Array.from(wrapper.childNodes).forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.indexOf('>>') !== -1) {
          node.textContent = node.textContent.replace(/>>/g, '').replace(/^\s+/, '');
        }
      });
    });
  }

  function trimAverage(root) {
    (root || document).querySelectorAll('.jdgm-rev-widg__summary-average').forEach(function (el) {
      var trimmed = el.textContent.replace(/(\d+\.\d)\d+/, '$1');
      if (el.textContent !== trimmed) el.textContent = trimmed;
    });
  }

  function applyFixes(root) {
    stripReplyArrows(root);
    trimAverage(root);
  }

  function start() {
    applyFixes(document); // initial pass for already-rendered content

    var obs = new MutationObserver(function (mutations) {
      // Run once per batch; cheap enough and avoids per-node thrash.
      applyFixes(document);
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });

    // Safety net: a few delayed passes in case the observer is attached after
    // an early render (covers slow widget hydration without a visible flash).
    setTimeout(function () { applyFixes(document); }, 1500);
    setTimeout(function () { applyFixes(document); }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * Judge.me "Write a review" modal -- body-class method.
 *
 * Open/closed state is read from the wrapper's INLINE style.display ("" = open,
 * "none" = closed) -- NOT getComputedStyle, because theme.css pins the open form
 * to display:block !important.
 *
 * OPEN: add `jdgm-modal-open` to <body> in the capture phase, before Judge.me
 * reflows, so the form is already position:fixed when it appears.
 * CLOSE: never remove the class eagerly; the RAF loop drops it once inline
 * display reads "none".
 *
 * OPEN-AT-TOP: Judge.me auto-focuses its first field on open, which scrolls the
 * modal past its heading. We do NOT focus, and for a short window after open we
 * blur any field that grabs focus and reset scrollTop.
 *
 * CLEAR ERRORS ON OPEN: Judge.me re-shows the SAME form instance (it doesn't
 * rebuild it), so validation error state from a previous submit lingers and
 * would show stale field highlights on reopen. On open we strip the
 * `jdgm-input-error` class from fields and empty the message divs, so every
 * open starts clean.
 *
 * COPY SWAP (Editorial Noir): Judge.me's Text-tab customizer is Awesome-plan
 * only, so on the Free plan the form's labels/placeholders/buttons are swapped
 * here in JS. applyCopy() runs inside openState() (after the fields exist) and
 * is idempotent, so it's safe to re-run every open. Selectors target the
 * standard in-store full-form fields; anything not present is skipped.
 */
(function () {
  'use strict';

  var BODY_CLASS = 'jdgm-modal-open';
  var BUTTON_SEL = '.jdgm-write-rev-link';
  var WRAPPER_SEL = '.jdgm-form-wrapper';
  var CLOSE_ID = 'jdgm-modal-close';
  var FOCUS_SUPPRESS_MS = 700;

  var raf = null;
  var scrollbarPad = '';
  var suppressFocusUntil = 0;

  // ---- Editorial Noir copy -------------------------------------------------
  var COPY = {
    title: 'Share your experience',
    ratingLabel: 'How would you rate it?',
    titlePlaceholder: 'Sum it up in a few words',
    contentPlaceholder: 'Tell others what you loved \u2014 the results, the feel, the difference it made',
    namePlaceholder: "The name you'd like shown",
    emailPlaceholder: 'Your email (kept private)',
    submit: 'Submit review',
    cancel: 'Cancel'
  };

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }
  function setPlaceholder(el, text) {
    if (el && el.getAttribute('placeholder') !== text) {
      el.setAttribute('placeholder', text);
    }
  }
  // Find the <label> inside the form whose own text matches `re` (Judge.me's
  // Rating + Email + Picture labels carry NO class, so we match by text).
  function labelByText(wrapper, re) {
    var labels = wrapper.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      if (re.test((labels[i].textContent || '').trim())) return labels[i];
    }
    return null;
  }

  // Swap the form copy. Idempotent: only writes when the value differs.
  // Fields are targeted by their `name` attribute (the inputs have NO class on
  // this install); labels with no class are matched by text.
  function applyCopy(wrapper) {
    if (!wrapper) return;

    // Modal heading ("Write a review")
    setText(wrapper.querySelector('.jdgm-form__title'), COPY.title);

    // Rating label ("Rating") -- classless <label>, match by text
    setText(labelByText(wrapper, /^rating$/i), COPY.ratingLabel);

    // Field placeholders -- target by name attribute
    setPlaceholder(wrapper.querySelector('[name="review_title"]'), COPY.titlePlaceholder);
    setPlaceholder(wrapper.querySelector('[name="review_body"]'), COPY.contentPlaceholder);
    setPlaceholder(wrapper.querySelector('[name="reviewer_name"]'), COPY.namePlaceholder);
    setPlaceholder(wrapper.querySelector('[name="reviewer_email"]'), COPY.emailPlaceholder);

    // Submit button: input[type=submit].jdgm-submit-rev -> uses .value
    var submit = wrapper.querySelector('.jdgm-submit-rev');
    if (submit) {
      if (submit.tagName === 'INPUT') {
        if (submit.value !== COPY.submit) submit.value = COPY.submit;
      } else {
        setText(submit, COPY.submit);
      }
    }

    // Cancel button: a.jdgm-cancel-rev ("Cancel review")
    setText(wrapper.querySelector('.jdgm-cancel-rev'), COPY.cancel);
  }
  // --------------------------------------------------------------------------

  function isOpen() {
    var w = document.querySelector(WRAPPER_SEL);
    return !!w && w.style.display !== 'none';
  }

  function scrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
  function lockScroll() {
    var w = scrollbarWidth();
    if (w > 0) {
      scrollbarPad = document.body.style.paddingRight;
      document.body.style.paddingRight = w + 'px';
    }
  }
  function unlockScroll() {
    document.body.style.paddingRight = scrollbarPad;
    scrollbarPad = '';
  }

  // Clear lingering validation state so each open starts clean.
  function clearErrors(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('input.jdgm-input-error, textarea.jdgm-input-error')
      .forEach(function (f) { f.classList.remove('jdgm-input-error'); });
    wrapper.querySelectorAll('div.jdgm-input-error')
      .forEach(function (d) { d.textContent = ''; });
  }

  function focusGuard(e) {
    if (Date.now() >= suppressFocusUntil) return;
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA') &&
        t.closest(WRAPPER_SEL)) {
      t.blur();
      var w = document.querySelector(WRAPPER_SEL);
      if (w) w.scrollTop = 0;
    }
  }

  function injectCloseBtn(wrapper) {
    if (!wrapper || wrapper.querySelector('#' + CLOSE_ID)) return;
    var btn = document.createElement('button');
    btn.id = CLOSE_ID;
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = '&times;';
    btn.style.cssText =
      'position:absolute;top:14px;right:16px;z-index:10;' +
      'width:34px;height:34px;line-height:1;padding:0;margin:0;' +
      'background:transparent;border:none;cursor:pointer;' +
      'font-size:26px;font-weight:300;color:#111;' +
      'display:flex;align-items:center;justify-content:center;';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }
    wrapper.appendChild(btn);
  }

  // Judge.me animates the form open with jQuery slideDown(), which writes inline
  // height/padding-top/margin-top frame by frame -- a visible slide. Inline styles
  // set by JS can't be stopped with CSS, and a RAF loop races the animation and
  // misses frames. A MutationObserver on the wrapper's style attribute strips the
  // slide styles the instant jQuery writes them, so the form stays at full height
  // (no slide). The observer is armed once and runs continuously; it only acts
  // when slide styles are present, so it's idle the rest of the time.
  var slideObs = null;

  function killSlideStyles(w) {
    if (!w) return;
    if (w.style.height) w.style.height = '';
    if (w.style.paddingTop) w.style.paddingTop = '';
    if (w.style.marginTop) w.style.marginTop = '';
    if (w.style.overflow === 'hidden') w.style.overflow = '';
  }

  function armSlideKill() {
    var w = document.querySelector(WRAPPER_SEL);
    if (!w || slideObs) return;
    killSlideStyles(w); // strip anything already set
    slideObs = new MutationObserver(function () {
      killSlideStyles(document.querySelector(WRAPPER_SEL));
    });
    slideObs.observe(w, { attributes: true, attributeFilter: ['style'] });
  }

  function openState() {
    if (document.body.classList.contains(BODY_CLASS)) return;
    document.body.classList.add(BODY_CLASS);
    lockScroll();
    armSlideKill();
    killSlideStyles(document.querySelector(WRAPPER_SEL));
    suppressFocusUntil = Date.now() + FOCUS_SUPPRESS_MS;
    var wrapper = document.querySelector(WRAPPER_SEL);
    if (wrapper) {
      clearErrors(wrapper);
      applyCopy(wrapper);
      injectCloseBtn(wrapper);
      wrapper.scrollTop = 0;
    }
  }

  function closeState() {
    if (!document.body.classList.contains(BODY_CLASS)) return;
    document.body.classList.remove(BODY_CLASS);
    unlockScroll();
  }

  function closeModal() {
    // Hide SYNCHRONOUSLY before triggering Judge.me's close. On desktop, Judge.me
    // animates the still-fixed form down the screen during close, which the RAF
    // loop only catches a frame later -- producing a visible "slide down" flash.
    // Hiding the wrapper (inline display:none) and dropping the body class right
    // now makes the form vanish instantly; Judge.me re-shows it (clears its own
    // inline display) the next time the button is clicked, so reopening is fine.
    var w = document.querySelector(WRAPPER_SEL);
    if (!w || w.style.display === 'none') return; // already closed
    w.style.display = 'none';
    closeState();
    var btn = document.querySelector(BUTTON_SEL);
    if (btn) btn.click(); // let Judge.me sync its own internal state
  }

  function onButtonClickCapture(e) {
    var trigger = e.target.closest(BUTTON_SEL);
    if (!trigger) return;
    if (!isOpen()) {
      openState();
    }
  }

  function sync() {
    if (isOpen()) {
      openState();
    } else {
      closeState();
    }
  }

  function loop() {
    sync();
    raf = (isOpen() || Date.now() < loopUntil) ? requestAnimationFrame(loop) : null;
  }
  var loopUntil = 0;
  function kick() { loopUntil = Date.now() + 2500; if (!raf) raf = requestAnimationFrame(loop); }

  function backdropClose(e) {
    if (!document.body.classList.contains(BODY_CLASS)) return;
    var wrapper = document.querySelector(WRAPPER_SEL);
    if (wrapper && !wrapper.contains(e.target) && !e.target.closest(BUTTON_SEL)) {
      closeModal();
    }
  }

  function escClose(e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains(BODY_CLASS)) return;
    closeModal();
  }


  // Badge click -> scroll reviews into view BELOW the sticky header.
  // Judge.me scrolls the preview badge with its own JS (native scroll-margin-top
  // is not honored), overshooting so the sticky header covers the "Customer
  // Reviews" title. We intercept the badge click and scroll ourselves with a
  // header-height offset so the title lands just below the header.
  var REVIEWS_SEL = '#judgeme_product_reviews';
  var BADGE_SEL = '.jdgm-prev-badge, .jdgm-prev-badge__stars';
  var HEADER_OFFSET = 160; // sticky header (~141px) + breathing room

  function badgeScroll(e) {
    var badge = e.target.closest(BADGE_SEL);
    if (!badge) return;
    var widget = document.querySelector(REVIEWS_SEL);
    if (!widget) return;
    e.preventDefault();
    e.stopPropagation();
    var y = widget.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  // Cancel button -> close instantly like the X, not Judge.me's slide animation.
  // Judge.me's native cancel animates the form sliding closed; our closeModal()
  // hides it synchronously (display:none) for an instant snap, matching the X.
  // We still let Judge.me sync its own state inside closeModal(), so this only
  // changes the visual close, not the underlying form logic.
  var CANCEL_SEL = '.jdgm-cancel-rev';

  function cancelClose(e) {
    var btn = e.target.closest(CANCEL_SEL);
    if (!btn) return;
    if (!document.body.classList.contains(BODY_CLASS)) return;
    e.preventDefault();
    e.stopPropagation();
    closeModal();
  }

  function init() {
    document.addEventListener('focusin', focusGuard, true);
    document.addEventListener('click', badgeScroll, true);
    document.addEventListener('click', cancelClose, true);
    document.addEventListener('click', onButtonClickCapture, true);
    document.addEventListener('click', kick, true); document.addEventListener('keydown', kick, true); kick(); // Oct 11: loop runs only around review-form use (was nonstop)
    document.addEventListener('click', backdropClose, true);
    document.addEventListener('keydown', escClose);
    document.addEventListener('jdgm:review:submitted', function () {
      setTimeout(closeModal, 1800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();